import React, { useState, useEffect } from "react";
import 'react-phone-number-input/style.css'
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'
import { PlaceHolder } from "../constants/PlaceHolderConstants";

export const PhoneNumberComponent = ({ setValues, setErrors, filedName, values, errors, defaultCountry, inputId, name }) => {
    const HandleChangePhone = (value, name) => {
        const item = value && formatPhoneNumber(value)
        // setCurrentCountryCode(item)
        setErrors({
            ...errors,
            [name]: ""
        });
        setValues({
            ...values,
            [name]: value,
        });
    };

    return (
        <PhoneInput
            defaultCountry={defaultCountry || "QA"}
            international
            id={inputId || "phoneNo"}
            name={name || "phoneNo"}
            //onBlur={(e) => HandleBlur(e)}
            onChange={(value) => HandleChangePhone(value, filedName)}
            className="form-control"
            placeholder={PlaceHolder?.PHONE_NUMBER}
            enableSearch
            value={values[filedName]}
        />

    )
}



